// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
// import axios from 'axios'
//全局常量
import consts from './components/Consts'

import App from './App'
import routers from './routers'

//css
import "./assets/home/css/contact-form-7.css"
import "./assets/home/css/popupally-style.css"
import "./assets/home/css/panels.css"
import "./assets/home/css/dashicons.min.css"

import "./assets/home/css/tesseract-theme.css"
import "./assets/home/css/typicons.css"
import "./assets/home/css/site-banner.css"
import "./assets/home/css/footer-banner.css"

//dialog弹窗插件
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VuejsDialog from "vuejs-dialog"
Vue.use(VuejsDialog, {
	html: true,
	okText: 'Continue',
	cancelText: 'Cancel',
	animation: 'bounce',
	backdropClose: true,
});

Vue.config.productionTip = false

//全局配置
// Vue.prototype.$ajax = axios
// Vue.prototype.$dialog = VuejsDialog
Vue.prototype.$consts = consts

Vue.use(VueRouter)
const router = new VueRouter({
	// base: consts.basePath,
	mode: 'history',
	routes: routers
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router: router,
	components: {
		App
	},
	template: '<App/>',
	created: function() {},
	methods: {

	},
})



// WEBPACK FOOTER //
// ./src/main.js